<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}`">{{ this.$store.state.client.name }}</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Mobile devices</a></li>
      </ul>
    </nav>

    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.clientDevicesTotal | numberDisplay }}</strong> mobile devices</p>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Model</th>
          <th>Manufacturer</th>
          <th>Platform</th>
          <th>Version</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.clientDevices.length">
          <td colspan="7" class="has-text-centered has-text-grey">No mobile devices found</td>
        </tr>
        <tr v-for="item in this.$store.state.clientDevices">
          <td>{{ item.id }}</td>
          <td>{{ item.model }}</td>
          <td>{{ item.manufacturer }}</td>
          <td>{{ item.platform }}</td>
          <td>{{ item.platform_ver }}</td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.clientDevicesTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      }
    },

    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      })

      this.$store.dispatch('getClientDevices', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getClientDevices', {
          clientId: this.$route.params.client_id,
          params: this.$route.query
        })
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// DeviceList.vue?b050af4a